export function hasShippableItems(checkout) {
  var _checkout$lineItems;
  return ((_checkout$lineItems = checkout.lineItems) == null ? void 0 : _checkout$lineItems.some(lineItem => {
    var _lineItem$physicalPro;
    return (_lineItem$physicalPro = lineItem.physicalProperties) == null ? void 0 : _lineItem$physicalPro.shippable;
  })) ?? false;
}
//# sourceMappingURL=hasShippableItems.js.map